export default __webpack_public_path__ + "assets/images/198fe0dd285564d18cacd8d538f99bd7.png";